import { render, staticRenderFns } from "./HomeBrandsAvailable.vue?vue&type=template&id=f24e79ae&scoped=true&"
var script = {}
import style0 from "./HomeBrandsAvailable.vue?vue&type=style&index=0&id=f24e79ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24e79ae",
  null
  
)

export default component.exports